module.exports = __webpack_public_path__ + "img/112.7c444a78.jpg";